<div class="analytics-header">
  <h1>Analytics</h1>
  @if (nativeTeamContextReady && isNativeTeamContextActive) {
    <section
      class="native-team-context"
      aria-label="Analytics Team context"
      >
      <div class="native-team-summary">
        <span class="native-team-label">Team</span>
        <strong>{{selectedNativeTeam?.name || 'No Team selected'}}</strong>
      </div>
      @if (nativeTeams.length > 1) {
        <mat-form-field appearance="outline">
          <mat-label>Team</mat-label>
          <mat-select [value]="selectedTeamId" (selectionChange)="onNativeTeamChange($event.value)">
            @for (team of nativeTeams; track team) {
              <mat-option [value]="team.id">{{team.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (nativeTeams.length === 0) {
        <span class="native-team-empty">
          No Teams are available for this company.
        </span>
      }
    </section>
  }
</div>

<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a mat-tab-link [routerLink]="link.link" (click)="activeLink = link" [active]="activeLink === link">
      {{link.title}}
    </a>
  }
</nav>

@if (analyticsLoadError) {
  <p class="analytics-load-error">{{analyticsLoadError}}</p>
}
@if (!analyticsLoading && analytics) {
  @if (activeLink?.title === 'All Teams Overview') {
    <app-analytics-overview [analytics]="analytics"></app-analytics-overview>
  }
  @if (activeLink?.title === 'Current Team Overview') {
    <app-analytics-team-overview [analytics]="analytics"></app-analytics-team-overview>
  }
  @if (activeLink?.title === 'Fund Allocation Overview' && areReportsEnabled) {
    <app-analytics-allocation-report></app-analytics-allocation-report>
  }
  @if (activeLink?.title === 'Allowance Allocation' && areReportsEnabled) {
    <app-analytics-allowance-allocation-report></app-analytics-allowance-allocation-report>
  }
  @if (activeLink?.title === 'Rewards Report' && areReportsEnabled) {
    <app-analytics-rewards-report></app-analytics-rewards-report>
  }
  @if (activeLink?.title === 'Spending Report' && areReportsEnabled) {
    <app-analytics-spending-report></app-analytics-spending-report>
  }
  @if (activeLink?.title === 'Payment Report' && areReportsEnabled) {
    <app-analytics-payment-report></app-analytics-payment-report>
  }
  @if (activeLink?.title === 'Members') {
    <app-analytics-members [analytics]="analytics"></app-analytics-members>
  }
  @if (activeLink?.title === 'Categories') {
    <app-analytics-categories [analytics]="analytics"></app-analytics-categories>
  }
  @if (activeLink?.title === 'Reimbursements') {
    <app-analytics-reimbursements [analytics]="analytics"></app-analytics-reimbursements>
  }
  @if (activeLink?.title === 'All Teams Allowances') {
    <app-analytics-allowances [analytics]="analytics"></app-analytics-allowances>
  }
  @if (activeLink?.title === 'Current Team Allowances') {
    <app-analytics-team-allowances [analytics]="analytics"></app-analytics-team-allowances>
  }
  @if (activeLink?.title === 'Peer To Peer') {
    <app-analytics-peer-to-peer></app-analytics-peer-to-peer>
  }
}
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
